<sm-title-bar pageTitle="Followers" [backWithParams]="true"> </sm-title-bar>





  <div class="customer_card" *ngIf="!loader && followersData.length > 0">
    <div class="row">
      <div class="col-sm-6 col-md-6 col-12" *ngFor="let item of followersData">
    <mat-card>
    <div class="package-card" >
      <div class="package-header">
        <div class="profile-container">
          <div class="booking-initial" *ngIf="!item.profile_thumb || item.profile_thumb == 'null'">{{item.name.slice(0,1).toUpperCase()}}</div>
          <div class="profile-image booking-initial-img" *ngIf="item.profile_thumb && item.profile_thumb != 'null'">
            <!-- <span class="initials" *ngIf="!item.profile_thumb || item.profile_thumb == 'null'">N</span> -->
            <img class="img-fluid rounded-circle" [src]="item.profile_thumb" alt=""  onerror="this.src='../../../../assets/images/user-avatar.svg'">
          </div>

          <div class="profile_texc">
          <h2 class="package-title">{{item.name}}</h2>
          <p class="package-detail" style="    margin-left: 5px;
">{{item.address}}</p>
        </div>

        </div>
    
        

        <button mat-icon-button [matMenuTriggerFor]="menu" class="package-options" >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
         
         <button mat-menu-item  (click)="openMessages(item)">
      <mat-icon class="material-icons-outlined">chat</mat-icon>
      <span>Send message</span>
    </button>
        </mat-menu>
        
      </div>
      
    
      <p class="package-highlight"><span class="deo_heading" ></span>  <span class="cureent_ht" *ngIf="item.gender && item.gender != '---'">{{item.gender}}, </span><span class="deo_heading" >DOB: </span>  <span class="cureent_ht" *ngIf="item.dob1 && item.dob1 != '---' && item.dob1 != 'null'">{{item.dob1}}</span></p>
      <p class="package-date"><span class="deo_heading">Follower since: </span> <span class="cureent_ht">{{item.favourited_on_date}}</span></p>
    </div>
  </mat-card>
    </div>
    </div>
  </div>



  <!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->
  
    <!-- placeholder html start -->
  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!loader && followersData.length == 0">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/follwer-1.png">
                 </div>
                 <mat-card-title>No followers yet
                </mat-card-title>
                 <mat-card-content>
                  Nobody is following your business or added as favorite in the LookzUp network. You can post feeds, promote with offers and communicate with your customers to get the followers. Build trust and grow.  
                </mat-card-content>
                <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openLink('https://lookzup.com/help')"
                  >
                    <mat-icon>help</mat-icon>
                   See help doc
                 </button>
                 </div> -->
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in getting the list of followers or if your customer
                   encountered one while follow, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 
  <!-- placeholder html end -->